import { UitkLoader } from 'uitk-react-loader';
import * as React from 'react';

export interface ISaveState {
  isSaving: boolean;
}

export class Loader extends React.Component<{}, {}> {
  public render() {
    return <UitkLoader className="all-t-margin-four all-b-margin-four" />;
  }
}

export default Loader;
